











































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { BillShort as IBill } from "@/api/models/bill-short";
import { ActShort as IAct } from "@/api/models/act-short";
import Doughnut from "@/components/companies/Doughnut.vue";

@Component({
  components: { Doughnut }
})
export default class MoneyBlockItemStatistic extends Vue {
  @Prop() bills!: Array<IBill>;
  @Prop() acts!: Array<IAct>;

  get allBillsPayment() {
    return this.sortedBillsPayments(this.bills);
  }

  get allBillsPrice() {
    return this.sortedByPrice(this.bills);
  }

  get allActsSignedPrice() {
    return this.sortedActsSignedPrice(this.acts, true);
  }

  get allActsNotSignedPrice() {
    return this.sortedActsSignedPrice(this.acts, false);
  }

  sortedByPrice(items: Array<IBill | IAct>) {
    let sorted = items?.map(el => {
      return el.price;
    });
    return sorted.length ? sorted.reduce((a, b) => a + b, 0) : 0;
  }

  sortedActsSignedPrice(items: Array<IAct>, signed: boolean) {
    let allSignedActs = items
      ?.filter(el => (signed ? el.signedAt : !el.signedAt))
      ?.map(el => el.price);

    return allSignedActs.length ? allSignedActs.reduce((a, b) => a + b, 0) : 0;
  }

  sortedBillsPayments(items: Array<IBill>) {
    let billsPayments = items?.map(el => {
      return el.payments?.map(payment => payment.amount);
    });

    return billsPayments.length
      ? billsPayments?.flat().reduce((a, b) => a! + b!, 0)
      : 0;
  }
}
